<div class="cdp-row" [formGroup]="minMaxSelectGroup">
    <hc-form-field class="col-6">
        <input hcInput placeholder="Min" type="number" min="0" max="max" formControlName="selectedMinItemsControl" />
    </hc-form-field>
    <hc-form-field class="col-6">
        <input hcInput placeholder="Max" type="number" min="min" formControlName="selectedMaxItemsControl" />
    </hc-form-field>
</div>
